import type { GroupWithArticles } from "./types"
import { isPublicTreeRow } from "./article-kind"

// The public tree, with Agent and Internal rows stripped out. A group that is
// left with nothing drops out too, unless it was empty to begin with: an empty
// group is a place to write the next article, one full of hidden rows is not.
export function toPublicTreeGroups(
	groups: readonly GroupWithArticles[],
): GroupWithArticles[] {
	return groups.flatMap((group) => {
		const helpCenterArticles = group.helpCenterArticles
			.filter(isPublicTreeRow)
			.map((article) => ({
				...article,
				subpages: article.subpages?.filter(isPublicTreeRow),
			}))
		if (
			helpCenterArticles.length === 0 &&
			group.helpCenterArticles.length > 0
		) {
			return []
		}
		return [{ ...group, helpCenterArticles }]
	})
}
